// extracted by mini-css-extract-plugin
export default {"title":"_52e7c32779","inner_title":"d810932d62","charge_btn":"_0d823cb593"};